export * from "ce/pages/Editor/Explorer/helpers";
import type { ModuleInstance } from "ee/constants/ModuleInstanceConstants";
import { matchBuilderPath, matchViewerPath } from "constants/routes";
import { matchUIPackageEditorPath } from "ee/constants/routes/packageRoutes";

export interface ExplorerURLParams {
  basePageId: string;
  workflowId?: string;
}

export interface ExplorerFileEntityForModule {
  type: "moduleInstance" | "group";
  group?: string;
  entity: ModuleInstance;
}

export const hasNavigatedOutOfPage = (
  previousUrl: string,
  currentUrl: string,
) => {
  const matchBuilderPath_Previous = matchBuilderPath(previousUrl, {
    end: false, // to match with entity paths (e.g. jsobject path)
  });
  const matchBuilderPath_Current = matchBuilderPath(currentUrl, {
    end: false,
  });
  const matchViewerPath_Previous = matchViewerPath(previousUrl);
  const matchViewerPath_Current = matchViewerPath(currentUrl);

  if (matchBuilderPath_Previous)
    return matchBuilderPath_Current
      ? matchBuilderPath_Previous.params.basePageId !==
          matchBuilderPath_Current.params.basePageId
      : true;
  else if (matchViewerPath_Previous)
    return matchViewerPath_Current
      ? matchViewerPath_Previous.params.basePageId !==
          matchViewerPath_Current.params.basePageId
      : true;

  return false;
};

export const isUIPackageEditorPath = (path: string) => {
  return Boolean(matchUIPackageEditorPath(path));
};
